import React from 'react';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
//{ phoneNumber, message }
const WhatsAppButton = () => {
  // Format the URL
  const phoneNumber = '+919450887365'; // Replace with your WhatsApp phone number
  const message = ''; //'Admin! Help on following Topic'
  const whatsappLink = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;



  return (
    <a
    href={whatsappLink}
    target="_blank"
    rel="noopener noreferrer"
    style={{
      position: 'fixed',
      bottom: '20px',
      right: '20px',
      backgroundColor: '#25D366', // WhatsApp green color
      color: 'white',
      borderRadius: '60%',
      padding: '15px',
      boxShadow: '0 4px 10px rgba(0, 0, 0, 0.2)',
      
      cursor: 'pointer',
      textDecoration: 'none',
    }}
  >
    <WhatsAppIcon />
  </a>
  );
};

export default WhatsAppButton;
